module.exports = __webpack_public_path__ + "img/solution-pc-200.8ed1ee2d.png";